import React from 'react';

const Resume = ({ data }) => {
    const skillmessage = Array.isArray(data?.skillmessage)
        ? data.skillmessage
        : [];

    const education = Array.isArray(data?.education)
        ? data.education.map(function (educationItem) {
              return (
                  <div key={educationItem.school}>
                      <h3>{educationItem.school}</h3>
                      <p className="info">
                          {educationItem.degree} <span>&bull;</span>
                          <em className="date">{educationItem.graduated}</em>
                      </p>
                      <p>{educationItem.description}</p>
                  </div>
              );
          })
        : [];

    const work = Array.isArray(data?.work)
        ? data.work.map(function (workItem) {
              return (
                  <div key={workItem.company}>
                      <h3>{workItem.company}</h3>
                      <p className="info">
                          {workItem.title}
                          <span>&bull;</span>{' '}
                          <em className="date">{workItem.years}</em>
                      </p>
                      <ul>
                          {(Array.isArray(workItem.description)
                              ? workItem.description
                              : []
                          ).map(function (description) {
                              return <li key={description}>{description}</li>;
                          })}
                      </ul>
                  </div>
              );
          })
        : [];

    const skills = Array.isArray(data?.skills)
        ? data.skills.map(function (skillItem) {
              const className =
                  'bar-expand ' + skillItem.name.toLowerCase();
              return (
                  <li key={skillItem.name}>
                      <span
                          style={{ width: skillItem.level }}
                          className={className}
                      ></span>
                      <em>{skillItem.name}</em>
                  </li>
              );
          })
        : [];

    return (
        <section id="resume">
            <div className="row education">
                <div className="three columns header-col">
                    <h1>
                        <span>Education</span>
                    </h1>
                </div>

                <div className="nine columns main-col">
                    <div className="row item">
                        <div className="twelve columns">{education}</div>
                    </div>
                </div>
            </div>

            <div className="row work">
                <div className="three columns header-col">
                    <h1>
                        <span>Work</span>
                    </h1>
                </div>

                <div className="nine columns main-col">{work}</div>
            </div>

            <div className="row skill">
                <div className="three columns header-col">
                    <h1>
                        <span>Skills</span>
                    </h1>
                </div>

                <div className="nine columns main-col">
                    <p>
                        <ul
                            style={{ listStyle: 'none', padding: 0, margin: 0 }}
                        >
                            {skillmessage.map((skill, index) => (
                                <li key={index}>{skill}</li>
                            ))}
                        </ul>
                    </p>

                    <div className="bars">
                        <ul className="skills">{skills}</ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Resume;
